import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SavedMenu, SidebarMenu } from 'src/app/interfaces/masterpass/masterpass';
import { environment } from 'src/environments/environment';

export const RECENT_MENU_KEY = 'onepass-recent-menu'
export const FAVORITE_MENU_KEY = 'onepass-favorite-menu'
export const PINNED_PROJECTS_KEY = 'onepass-pinned-projects'

export enum MasterpassServiceType {
  DASHBOARD_SETTINGS,
  LANGUAGE_LIST,
  LANGUAGE_SELF,
  NOTES,
  MEMOS,
  MEMOS_MARK_READ,
  MEMOS_ACKNOWLEDGE,
  MEMOS_ATTACHMENT,
  BUSINESS_CARD
}

@Injectable({
  providedIn: 'root'
})
export class MasterpassService {

  private MP_URL: string;
  constructor(
    private httpSvc: HttpClient
  ) {
    this.MP_URL = environment.apiUrl;
  }

  getUrl(serviceType: MasterpassServiceType) {
    let url: string = '';
    switch (serviceType) {
      case MasterpassServiceType.DASHBOARD_SETTINGS:
        url = this.MP_URL + '/dashboard-settings';
        break;
      case MasterpassServiceType.LANGUAGE_LIST:
        url = this.MP_URL + '/languages/list';
        break;
      case MasterpassServiceType.LANGUAGE_SELF:
        url = this.MP_URL + '/languages/self';
        break;
      case MasterpassServiceType.NOTES:
        url = this.MP_URL + '/notes';
        break;
      case MasterpassServiceType.MEMOS:
        url = this.MP_URL + '/memo';
        break;
      case MasterpassServiceType.MEMOS_MARK_READ:
        url = this.MP_URL + '/memo/mark-read';
        break;
      case MasterpassServiceType.MEMOS_ACKNOWLEDGE:
        url = this.MP_URL + '/memo/acknowledge';
        break;
      case MasterpassServiceType.MEMOS_ATTACHMENT:
        url = this.MP_URL + '/memo/upload-attachment';
        break;
      case MasterpassServiceType.BUSINESS_CARD:
        url = this.MP_URL + '/business-card';
        break;
      default:
        break;
    }
    return url;
  }

  async create(serviceType: MasterpassServiceType, body: any, path: string = ''): Promise<Observable<any>> {
    return this.httpSvc.post(this.getUrl(serviceType) + '/' + path, body);
  }

  async delete(serviceType: MasterpassServiceType, path: string = ''): Promise<Observable<any>> {
    return this.httpSvc.delete(this.getUrl(serviceType) + '/' + path);
  }

  async detail(serviceType: MasterpassServiceType, path: string = ''): Promise<Observable<any>> {
    return this.httpSvc.get(this.getUrl(serviceType) + '/' + path);
  }

  async list(serviceType: MasterpassServiceType, path: string = ''): Promise<Observable<any>> {
    return this.httpSvc.get(this.getUrl(serviceType) + path);
  }

  async update(serviceType: MasterpassServiceType, body: any, path = ''): Promise<Observable<any>> {
    return this.httpSvc.put(this.getUrl(serviceType) + '/' + path, body);
  }

  async patch(serviceType: MasterpassServiceType, body: any, path = ''): Promise<Observable<any>> {
    return this.httpSvc.patch(this.getUrl(serviceType) + '/' + path, body);
  }

  getImage(serviceType: MasterpassServiceType, path = ''): Observable<Blob> {
    return this.httpSvc.get(this.getUrl(serviceType) + path, {
      responseType: 'blob'
    });
  }

  public getRecentMenu(): SavedMenu[] | null {
    const data = window.localStorage.getItem(RECENT_MENU_KEY);
    if (data) return JSON.parse(data);
    return null;
  }

  public setRecentMenu(data:SavedMenu[]){
    if (!data) return;

    window.localStorage.removeItem(RECENT_MENU_KEY);
    window.localStorage.setItem(RECENT_MENU_KEY, JSON.stringify(data));
  }

  public getFavoriteMenu(): SavedMenu[] | null {
    const data = window.localStorage.getItem(FAVORITE_MENU_KEY);
    if (data) return JSON.parse(data);
    return null;
  }

  public setFavoriteMenu(data:SavedMenu[]){
    if (!data) return;

    window.localStorage.removeItem(FAVORITE_MENU_KEY);
    window.localStorage.setItem(FAVORITE_MENU_KEY, JSON.stringify(data));
  }

  public getPinnedProjects(): string[] | null {
    const data = window.localStorage.getItem(PINNED_PROJECTS_KEY);
    if (data) return JSON.parse(data);
    return null;
  }

  public setPinnedProjects(data:string[]){
    if (!data) return;

    window.localStorage.removeItem(PINNED_PROJECTS_KEY);
    window.localStorage.setItem(PINNED_PROJECTS_KEY, JSON.stringify(data));
  }
}
